<template>

  <div class="conmain">
    <el-dropdown >
       <span class="el-dropdown-link">
         <el-button type="primary" round>新增试题</el-button>
       </span>
       <el-dropdown-menu slot="dropdown">
         <el-dropdown-item @click.native="() => subject_edit_click('add','','0')">添加判断</el-dropdown-item>
         <el-dropdown-item @click.native="() => subject_edit_click('add','','1')">添加选择</el-dropdown-item>
       </el-dropdown-menu>
    </el-dropdown>
    <el-button type="primary" round @click="subject_up_click()">批量上传</el-button>
    <el-table stripe :data="subject_list.data " style="width: 100%">
      <el-table-column label="编号" prop="num" sortable>
      </el-table-column>
      <el-table-column label="题型" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.type=='0'">判断</p>
           <p v-else>选择</p>
         </template>
      </el-table-column>
      <el-table-column label="题目" prop="name" width="400" sortable>
      </el-table-column>
      <el-table-column label="所属文档" prop="file" sortable>
      </el-table-column>
      <el-table-column label="级别" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.level=='0'">简单</p>
           <p v-if="scope.row.level=='1'">中等</p>
           <p v-if="scope.row.level=='2'">困难</p>
         </template>
      </el-table-column>
      <el-table-column label="状态" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.status=='1'">启用中</p>
           <p v-else>已禁用</p>
         </template>
      </el-table-column>
      <el-table-column align="right" width="300">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" style="width: 70%;" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="watch_subject(scope.row)">详情</el-button>
          <el-button size="mini" @click="subject_edit_click('edit',scope.row.num,'')">编辑</el-button>
          <el-button size="mini" type="success" v-if="scope.row.status!='1'" @click="subject_edit_click('del',scope.row.num,'')">启用</el-button>
          <el-button size="mini" type="danger" v-else @click="subject_edit_click('del',scope.row.num,'')">禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="subject_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="subject_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="subject_list.total">
      </el-pagination>
    </div>

    <el-dialog title="详情 " :visible.sync="nav_status.subject_info_dialog">
      <el-form>
        <el-form-item label="题干">
          <p>{{subject_info.name}}</p>
        </el-form-item>
        <el-form-item label="题型">
          <p v-if="subject_info.type=='1'">选择</p>
          <p v-if="subject_info.type=='0'">判断</p>
        </el-form-item>
        <el-form-item label="所属文档">
          <p>{{subject_info.file}}</p>
        </el-form-item>
        <el-form-item label="难易度" >
          <p v-if="subject_info.level=='0'">简单</p>
          <p v-if="subject_info.level=='1'">中等</p>
          <p v-if="subject_info.level=='2'">困难</p>
        </el-form-item>
        <el-form-item label="选项"  :visible.sync="nav_status.subject_info_choice_dialog">
          <!-- <p>{{subject_info.choice}}</p> -->
          <el-row>
            <p v-for="item in subject_info.choice">{{item}}</p >
          </el-row>
        </el-form-item>
        <el-form-item label="答案" >
          <p>{{subject_info.answer}}</p>
        </el-form-item>
        <el-form-item label="解析" >
          <p>{{subject_info.info}}</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nav_status.subject_info_dialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量上传" :visible.sync="nav_status.subject_up_dialog">
      <p>题型:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
       <el-select v-model="subject_up.type" filterable placeholder="请选择">
        <el-option label="判断" value="0">
        </el-option>
        <el-option label="选择" value="1">
        </el-option>
       </el-select>
      </p>
     <p>所属文档:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- <el-select v-model="subject_up.resource_type" filterable placeholder="请选择">
       <el-option
        v-for="item in file_list.data"
        :key="item.num"
        :label="item.name"
        :value="item.num">
       </el-option>
      </el-select> -->
      <div>{{file_name_up}}</div>
      <el-button plain @click="type_choice('all')">请选择</el-button>
     </p>
     <p>上传题库Excel
      <el-upload
        class="upload-demo"
        accept=".xlsx"
        ref="upload"
        action=""
        :http-request="excel_save"
        :on-exceed="excel_check"
        :file-list="fileList"
        :on-change="excel_change"
        :before-remove="excel_remove"
        :limit="1"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        </el-upload>
     </p>

     <a href="/static/subject_demo.zip" download="题库模版.zip"><el-button>点击下载模板</el-button></a>
     <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.subject_up_dialog=false">取 消</el-button>
      <el-button type="primary" @click="excel_submit()">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog title="题库预览" :visible.sync="nav_status.subject_up_watch_dialog">
       <div v-html="nav_status.subject_up_watch_html" style="overflow: auto;"></div>
       <div slot="footer" class="dialog-footer">
         <el-button @click="nav_status.subject_up_watch_dialog=false">关闭</el-button>
         <el-button type="primary" @click="subject_up_end()">保存</el-button>
       </div>
    </el-dialog>

    <el-dialog :title="nav_status.title" :visible.sync="nav_status.subject_edit_0_dialog">
      <p>题干:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-input v-model="subject_edit.name" autocomplete="off" style="width: 80%;"  placeholder="题干"></el-input>
      </p>
     <p>所属文档:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
     <!-- <el-select v-model="subject_edit.resource_type" filterable placeholder="请选择">
       <el-option
        v-for="item in file_list.data"
        :key="item.num"
        :label="item.name"
        :value="item.num">
       </el-option>
      </el-select> -->
      <el-button plain @click="type_choice('panduan')">请选择</el-button><span>{{file_name_edit}}</span>
     </p>
     <p>难易度:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-select v-model="subject_edit.level" style="width: 80%;">
          <el-option label="简单" value="0"></el-option>
          <el-option label="中等" value="1"></el-option>
          <el-option label="困难" value="1"></el-option>
        </el-select>
     </p>
     <p>答案:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-select v-model="subject_edit.answer" style="width: 80%;">
          <el-option label="错误" value="0"></el-option>
          <el-option label="正确" value="1"></el-option>
        </el-select>
     </p>
     <p>解析:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
       <el-input
         type="textarea"
         autosize
         placeholder="备注"
         v-model="subject_edit.info"
         style="width: 80%;">
       </el-input>
     </p>
     <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.subject_edit_0_dialog=false">取 消</el-button>
      <el-button type="primary" @click="subject_save()">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog :title="nav_status.title" :visible.sync="nav_status.subject_edit_1_dialog">
      <p>题干:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-input v-model="subject_edit.name" autocomplete="off" style="width: 80%;"  placeholder="题干"></el-input>
      </p>
     <p>所属文档:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- <el-select v-model="subject_edit.resource_type" filterable placeholder="请选择">
       <el-option
        v-for="item in file_list.data"
        :key="item.num"
        :label="item.name"
        :value="item.num">
       </el-option>
      </el-select> -->
      <el-button plain @click="type_choice('xuanze')">请选择</el-button><span>{{file_name_edit}}</span>
     </p>
     <p>难易度:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-select v-model="subject_edit.level" style="width: 80%;">
          <el-option label="简单" value="0"></el-option>
          <el-option label="中等" value="1"></el-option>
          <el-option label="困难" value="1"></el-option>
        </el-select>
     </p>
     <p>选项:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div v-for="(item,index) in choice_arr" :key="index">
          <span>{{index}}.</span><el-input type="textarea" autosize placeholder="选项内容" :value="item" v-model="item.choice" style="width: 80%;"></el-input>
          <input type="checkbox" v-model="item.answer">正确答案
        </div>
     </p>
     <p>解析:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
       <el-input
         type="textarea"
         autosize
         placeholder="备注"
         v-model="subject_edit.info"
         style="width: 80%;">
       </el-input>
     </p>
     <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.subject_edit_1_dialog=false">取 消</el-button>
      <el-button type="primary" @click="subject_save()">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog title="所属分类":visible.sync="nav_status.type_choice_dialog" :before-close="handleClose" width="80%">
      <div>
        <h4>您选择的是:
        <span  v-if="nav_status.type_choice_dialog_num" v-html="fenlei_type_all" ></span>
        </h4>
        <el-input
        style="margin: 0.625rem;"
        placeholder="输入关键字进行过滤"
        v-model="filterText">
        </el-input>
        <div>
         <el-row class="over" :style="{height:dialog_Height}">
           <el-tree
            :filter-node-method="filterNode"
              @node-click="type_fid"
               :data="file_list_type"
                ref="tree"
                node-key="num"
              >
               <span class="custom-tree-node" slot-scope="{data}">
                 <div class="dia_tree_data" :style="{width:dialog_width}" >{{ data.name }}</div>
               </span>
           </el-tree>
         </el-row>
        </div>
      </div>
       <div slot="footer" class="dialog-footer">
         <el-button  @click="nav_status.type_choice_dialog = false">取 消</el-button>
         <el-button type="primary" @click="nav_status.type_choice_dialog = false">确 定</el-button>
       </div>
    </el-dialog>

  </div>

</template>

<script>
  export default {
    watch: {
         filterText(val) {
           this.$refs.tree.filter(val);
         }
       },
    data() {
      return {
        fenlei_type_all:'',
        fenlei_type_dialog:'',
        file_list_type:[],
        filterText:'',
        dialog_width:window.innerWidth -500 + 'px',
        dialog_Height:window.innerHeight * 0.5 + 'px',
        choice_arr:{
          'A':{'choice':'','answer':false},
          'B':{'choice':'','answer':false},
          'C':{'choice':'','answer':false},
          'D':{'choice':'','answer':false},
          'E':{'choice':'','answer':false},
          'F':{'choice':'','answer':false},
          'G':{'choice':'','answer':false},
          'H':{'choice':'','answer':false}
        },
        nav_status:{
          subject_edit_dialog:false,
          subject_info_dialog:false,
          subject_info_choice_dialog:false,
          subject_up_dialog:false,
          subject_up_watch_dialog:false,
          subject_up_watch_html:'',
          subject_edit_0_dialog:false,
          subject_edit_1_dialog:false,
          title:'',
          type_choice_dialog:false,
          type_choice_dialog_num:true,
        },
        subject_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        file_list:{},
        subject_info:{},
        subject_edit:{},
        fileList: [],
        subject_up:{
          type:'0',
          // resource_type:''
        },
        search: '',
        file_name_up:'',
        file_name_edit:''
      }
    },
    components: {},
    mounted() {
      this.get_subject()
      this.get_file()
    },
    methods: {
      type_fid(data){
        let _this=this
        if(!data.hasOwnProperty('children')){
          _this.nav_status.type_choice_dialog_num=false
          _this.fenlei_type_all=data.name
          _this.nav_status.type_choice_dialog_num=true
           if(_this.fenlei_type_dialog=='all'){
             _this.subject_up.resource_type=data.file
             _this.file_name_up=data.name
           }else{
             _this.subject_edit.resource_type=data.file
             _this.file_name_edit=data.name
           }
        }

      },
      filterNode(value, data) {
         if (!value) return true;
         return data.name.indexOf(value) !== -1;
       },
      handleClose(done) {
        let _this=this
        _this.$confirm('确认所选分类？').then(_ => {
          done();
        })
        .catch(_ => {});
      },
      type_choice(type){
        this.fenlei_type_all=''
        this.filterText=''
        this.fenlei_type_dialog=type
        this.nav_status.type_choice_dialog=true
      },
      search_click(){
        this.get_subject()
      },
      get_file(){
        let _this=this
        _this.axios
          .get("/v2/user_resource/get_file_type")
          .then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                  _this.file_list_type=res.data.data
              } else {
                _this.$message.error("服务器内部错误");
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          });
        _this.axios.get('/v2/c_resource/get_file',{params:{'page':'1','limit':'9999','status':'1'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.file_list=res.data.data
              _this.file_list.per_page=parseInt(_this.file_list.per_page)
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_subject(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_subject_list',{params:{'page':_this.subject_list.current_page,'limit':_this.subject_list.per_page,'type':'2','keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.subject_list=res.data.data
              _this.subject_list.per_page=parseInt(_this.subject_list.per_page)
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.subject_list.current_page = 1
        this.subject_list.per_page = val
        this.get_subject()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.subject_list.current_page = val
        _this.get_subject()
      },

      watch_subject(subject){
        let _this=this
        _this.subject_info.name=subject.name
        _this.subject_info.type=subject.type
        _this.subject_info.file=subject.file
        _this.subject_info.level=subject.level
        _this.subject_info.answer=subject.answer
        _this.subject_info.info=subject.info
        _this.subject_info.choice=[]
        _this.nav_status.subject_info_choice_dialog=false
        if(subject.type=='1'){
          _this.nav_status.subject_info_choice_dialog=true
          var choice=subject.choice.split('----')
          let list=''
          for(var i=0;i<choice.length;i++){
            list=String.fromCharCode(65+i)+'.'+choice[i]
            _this.subject_info.choice[i]=list
            list=''
          }
        }
        if(subject.type=='0'){
          if(subject.answer=='0'){
            _this.subject_info.answer='错误'
          }else{
            _this.subject_info.answer='正确'
          }
        }
        _this.nav_status.subject_info_dialog=true
      },

      subject_up_click(){
        this.file_name_up=''
        this.subject_up={
          type:'0'
        }
        if(this.$refs.upload){
          this.$refs.upload.clearFiles()
        }
        this.nav_status.subject_up_dialog=true
      },

      excel_check(){
        let _this=this
        _this.$message.error('请先删除列表中的Excel文件')
      },

      excel_change(file, fileList){
        let _this=this
        _this.fileList=fileList
      },

      excel_remove(){
        this.fileList=[]
      },

      excel_submit(){
        let _this=this
        if(_this.fileList==0){
          _this.$message.error('请选择Excel文件')
        }else{
          _this.$refs.upload.submit()
        }
      },

      excel_save(file){
        let _this=this
        var files =file.file
        var data = new FormData();
        data.append('type',_this.subject_up.type)
        data.append('resource_type',_this.subject_up.resource_type)
        data.append("subject", files)
        _this.axios.post('/v2/c_resource/subject_up_check',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.nav_status.subject_up_watch_html=res.data.data
              _this.nav_status.subject_up_watch_dialog=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      subject_up_end(){
        let _this=this
        _this.axios.post('/v2/c_resource/subject_submit',{data:'file'}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.subject_up_watch_html=''
              _this.nav_status.subject_up_watch_dialog=false
              _this.nav_status.subject_up_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      subject_up_watch_close(){
        this.nav_status.subject_up_watch_dialog=true
      },

      subject_edit_clear(){
        this.subject_edit={}
        this.choice_arr={
          'A':{'choice':'','answer':false},
          'B':{'choice':'','answer':false},
          'C':{'choice':'','answer':false},
          'D':{'choice':'','answer':false},
          'E':{'choice':'','answer':false},
          'F':{'choice':'','answer':false},
          'G':{'choice':'','answer':false},
          'H':{'choice':'','answer':false}
        }
      },

      subject_edit_click(type,num,subject_type){
        let _this=this
        _this.file_name_edit=''
        _this.subject_edit_clear()
        _this.subject_edit.type=type
        _this.subject_edit.subject_type=subject_type
        if(type=='add'){
          _this.nav_status.title='添加'
          _this.show_subject_edit_dialog(subject_type)
        }
        if(type=='edit'){
          _this.nav_status.title='编辑'
          _this.get_subject_info(num)
        }
        if(type=='del'){
          _this.axios.post('/v2/c_resource/subject_up',{data:{'type':'del','num':num,'resource':'2'}}).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.$message.success(res.data.msg)
                _this.get_subject()
              }else{
                _this.$message.error(res.data.msg)
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }
      },

      show_subject_edit_dialog(subject_type){
        let _this=this
        if(subject_type=='0'){
          _this.nav_status.subject_edit_0_dialog=true
        }else{
          _this.nav_status.subject_edit_1_dialog=true
        }
      },

      get_subject_info(num){
        let _this=this
        _this.axios.get('/v2/c_resource/get_subject_info',{params:{'type':'2','num':num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$set(_this.subject_edit,'name',res.data.data.name)
              _this.$set(_this.subject_edit,'level',res.data.data.level)
              _this.$set(_this.subject_edit,'info',res.data.data.info)
              _this.$set(_this.subject_edit,'resource_type',res.data.data.f_id)
              _this.file_name_edit=res.data.data.file_name
              _this.subject_edit.num=res.data.data.num
              _this.change_subject_choice(res.data.data)
              _this.show_subject_edit_dialog(res.data.data.type)
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      change_subject_choice(subject){
        let _this=this
        _this.subject_edit.subject_type=subject.type
        if(subject.type=='0'){
          _this.$set(_this.subject_edit,'answer',subject.answer)
        }else{
          var arr=['A','B','C','D','E','F','G','H']
          var choice=subject.choice.split('----')
          var answer=subject.answer.split('----')
          for(var i=0;i<choice.length;i++){
            _this.choice_arr[arr[i]].choice=choice[i]
            if(answer.findIndex(item => item== arr[i])>-1){
              _this.choice_arr[arr[i]].answer=true
            }
          }

        }
      },

      subject_save(){
        let _this=this
        _this.subject_edit.resource='2'
        if(_this.subject_edit.subject_type=='0'){
          _this.subject_edit.choice=['0']
          _this.subject_edit.answer_re=[_this.subject_edit.answer]
        }else{
          var choice=[]
          _this.subject_edit.answer=[]
          for(let key in _this.choice_arr){
            if(_this.choice_arr[key].choice==''){
              break;
            }else{
              choice.push(_this.choice_arr[key].choice)
              if(_this.choice_arr[key].answer){
                _this.subject_edit.answer.push(key)
              }
            }
          }
          if(choice.length==0 || _this.subject_edit.answer.length==0){
            _this.$message.error('请填写选项或答案')
            return false
          }else{
            _this.subject_edit.choice=choice
          }
        }
        _this.axios.post('/v2/c_resource/subject_up',{data:_this.subject_edit}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_subject()
              _this.nav_status.subject_edit_0_dialog=false
              _this.nav_status.subject_edit_1_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      }

    },
  }
</script>

<style scoped>
  .conmain {
    width: 100%;
    height: 100%;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
  .over{
    overflow: auto;
    overflow-x:hidden;
  }
  >>>.el-tree>.el-tree-node {
    width: calc(100% - 45px);
    border: 2px solid #f6f8ff;
    /* box-shadow: 5px 5px 3px #f6f8ff; */
    padding: 5px;
    margin: 0.625rem;
  }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
   .tree_data{
     overflow: hidden;
     text-overflow: ellipsis;
   }
   .dia_tree_data{
     overflow-x: hidden;
     text-overflow: ellipsis;
   }
</style>



// WEBPACK FOOTER //
// src/view/company/course/SelfFile/Subject.vue